import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateGcWASettingForm } from '../../../../actions/waitingArea.js';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const GroupConsultationSettings = ({ waitingArea, showGCSettingsModal }) => {
  const dispatch = useDispatch();
  let title = APP.LANGUAGE.GCSettings.TitleUpdateAndView;
  let orgName = waitingArea ? waitingArea.organisationName : '';
  var updatingWaitingAreaName = (waitingArea ? waitingArea.name : '') + ' (' + orgName + ')';
  let subtitle = updatingWaitingAreaName;
  const gcWaitingAreaSettings = useSelector((state) => state.waitingAreaReducer.gcWaitingAreaSettings);
  const [validateForm, setValidateForm] = useState();
  const [saveButtonDisableClass, setSaveButtonDisableClass] = useState('disable');

  useEffect(() => {
    dispatch(
      updateGcWASettingForm({
        isChatEnabled:
          gcWaitingAreaSettings?.isChatEditable && !gcWaitingAreaSettings?.isOUChatEnabled
            ? false
            : gcWaitingAreaSettings?.isChatEnabled,
        isCallerFullNameEnabled:
          gcWaitingAreaSettings?.isCallerFullNameEditable && !gcWaitingAreaSettings?.isOUFullNameEnabled
            ? false
            : gcWaitingAreaSettings?.isCallerFullNameEnabled,
      })
    );
    setValidateForm({
      isChatEnabled:
        gcWaitingAreaSettings?.isChatEditable && !gcWaitingAreaSettings?.isOUChatEnabled
          ? false
          : gcWaitingAreaSettings?.isChatEnabled,
      isCallerFullNameEnabled:
        gcWaitingAreaSettings?.isCallerFullNameEditable && !gcWaitingAreaSettings?.isOUFullNameEnabled
          ? false
          : gcWaitingAreaSettings?.isCallerFullNameEnabled,
    });
  }, []);

  let rightPanel = (
    <RightPanelTop
      waitingArea={waitingArea}
      setSaveButtonDisableClass={setSaveButtonDisableClass}
      saveButtonDisableClass={saveButtonDisableClass}
      validateForm={validateForm}
      gcWaitingAreaSettings={gcWaitingAreaSettings}
    />
  );

  let centerPanel = (
    <CenterPanelUpdate
      gcWaitingAreaSettings={gcWaitingAreaSettings}
      setSaveButtonDisableClass={setSaveButtonDisableClass}
    />
  );

  return (
    <Modal show={showGCSettingsModal} hideWhenClickAway={false} className={'waiting-area-gc-setting'}>
      <PopupHeader title={title} subtitle={subtitle} helpLink={window.APP.EXTERNAL_LINKS.GCSetting.GCSettingDialog} />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              {rightPanel}
              <RightPanelBottom />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default GroupConsultationSettings;
